import React from 'react'

export default () => {
  const [print, setPrint] = React.useState(false)
  React.useEffect(() => {
    if (print) {
      setPrint(false)
      window.print()
    }
  }, [print])
  return [print, setPrint]
}
